import type {ReactAction} from '@netx/core/bootstrap';
import {faShare} from '@netx/core-icons';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {cartSavedActionShareLink} from './cart-saved-share-link';
import {cartSavedActionTeamAccess} from './cart-saved-share-team-access';

export const cartSavedActionShareMenuIcon = faShare;

/**
 * Saved cart share menu
 * @param params
 * @returns Action
 */
export const cartSavedActionShareMenu = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-share-menu',
	cb: () => {},
	icon: cartSavedActionShareMenuIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.MENU;
	},
	children: [
		cartSavedActionShareLink(savedCart),
		cartSavedActionTeamAccess(savedCart),
	],
	...params,
});

export default cartSavedActionShareMenu;
